import React from 'react'

import Temp from '../components/temp'


console.log("ImprovementsPage.jsx");

export default function TempPage() {
  return (
    <Temp/>
  )
}
